import { render, staticRenderFns } from "./wxPayQrCode.vue?vue&type=template&id=79b08716&scoped=true"
import script from "./wxPayQrCode.vue?vue&type=script&lang=js"
export * from "./wxPayQrCode.vue?vue&type=script&lang=js"
import style0 from "./wxPayQrCode.vue?vue&type=style&index=0&id=79b08716&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b08716",
  null
  
)

export default component.exports